@if (title || subtitle) {
  <div>
    <h1 class="text-2xl font-bold text-slate-800 tracking-tight">
      {{ title }}
    </h1>
    @if (subtitle) {
      <p class="text-sm text-slate-500 mt-1">
        {{ subtitle }}
      </p>
    }
  </div>
}

<ng-content></ng-content>
